import Hero from "@/components/Hero";
import ProductShowcase from "@/components/ProductShowcase";
import Marquee from "@/components/Marquee";
import KnowBrand from "@/components/KnowBrand";
import WhyGlutathione from "@/components/WhyGlutathione";
import HowItWorks from "@/components/HowItWorks";
import OpitacEdge from "@/components/OpitacEdge";
import Manifesto from "@/components/Manifesto";
import Ingredients from "@/components/Ingredients";
import SkinAnalysis from "@/components/SkinAnalysis";
import SunscreenCoach from "@/components/SunscreenCoach";
import AuthenticBatches from "@/components/AuthenticBatches";
import FindDoctorCTA from "@/components/FindDoctorCTA";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";

export default function Home() {
  return (
    <main>
      <Hero />
      <ProductShowcase />
      <Marquee />
      <KnowBrand />
      <WhyGlutathione />
      <HowItWorks />
      <OpitacEdge />
      <Manifesto />
      <Ingredients />
      <SkinAnalysis />
      <SunscreenCoach />
      <AuthenticBatches />
      <FindDoctorCTA />
      <Faq />
      <Contact />
    </main>
  );
}
